import * as React from 'react'
import * as Reakit from 'reakit/Tooltip'

interface TooltipButtonProps extends Reakit.TooltipReferenceHTMLProps {
  state: Reakit.TooltipStateReturn
}
/**
 * The trigger button component which handles ref & focus return, etc.
 */
export const TooltipTrigger = React.forwardRef(
  ({ state, ...props }: TooltipButtonProps, ref: React.ForwardedRef<HTMLDivElement>) => (
    <Reakit.TooltipReference ref={ref} {...props} {...state}>
      {props.children}
    </Reakit.TooltipReference>
  )
)
